var spoiler_default = {
  "fontElementMap": "JHakd",
  "hideText": "_1L6FX",
  "onHoverText": "xIlj9",
  "hideBlock": "od7pG",
  "smallBlur": "m-jrm",
  "mediumBlur": "NsiOG",
  "largeBlur": "OxnD2",
  "hideBlock_gallery": "RiM4P",
  "overlay": "CWU-n",
  "overlay_gallery": "sEBn3",
  "revealSpoilerBtn": "xfpnG",
  "isMobile": "f9j-A",
  "onHoverBtn": "_1dQKQ",
  "spoilerWrapper": "_2MMME",
  "spoilerDescription": "njpF7",
  "spoilerContainer": "MRALw",
  "spoilerContainer_Gallery": "_1F603"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
